// Change this to your actual backend domain
const BASE_URL = "https://www.actrofiteinfotech.com/rootservices"; 

export const API = {
  GET_SUB_SERVICES: `${BASE_URL}/get_sub_services.php`,
  UPLOAD_IMAGE: `${BASE_URL}/upload_image.php`,
};
